import { useMutation } from '@tanstack/react-query';
import { kycApi } from '@/api';

export const useQuestionnaire = ({ adminView, referralView }) => {
  const { mutateAsync: checkQuestionnaireStatus } = useMutation({
    mutationFn: adminView
      ? kycApi.checkQuestionnaireStatusForAdmin
      : referralView
        ? kycApi.checkReferralQuestionnaireStatus
        : kycApi.checkQuestionnaireStatus
  });

  return {
    checkQuestionnaireStatus
  };
};
